<div *ngIf="loading" class="loading-text">
    <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
  </div>

  <div *ngIf="!loading">
<app-sub-header [pageTitle]="getPageTitle()"></app-sub-header>

<div class="padded-container">
        <div *ngIf="deffectPositionsResponse?.deffectPostions">
            <div *ngFor="let item of deffectPositionsResponse?.deffectPostions">
                <dx-button
                    text="{{ item.name }}"
                    type="default"
                    class="full-width-button"
                    (onClick)="ContinueNextStep(item.id ?? 0, item.name)">
                </dx-button>
            </div>
        </div>
        <div *ngIf="!deffectPositionsResponse?.deffectPostions">
            Nav servisi
        </div>

        <div class="mt-1">
            <dx-button
                text="{{ 'Back' | translate }}"
                type="danger"
                class="full-width-button"
                (onClick)="backClick()">
            </dx-button>
        </div>
</div>
  </div>